<!-- <div id="tutorial" class="btn-header transparent hidden-xs hidden-sm hidden-md helpIcon cursor-pointer">
  <span> 
    <a (click)="openTutorial()" title="{{'common_all_header_icon_help' | i18n}}">
      <i class="fa fa-question"></i>
    </a>
  </span>
</div> -->

<div id="helpTutorial" [saJquiDialog]="tutorialHelpOptions">
  <div *ngIf="hideSearch" class='ghp-header-searchFormContainer'>
    <form class='ghp-header-searchForm'><input id='search-box' class='ghp-header-searchBox' ghp-autocomplete=''
        type='text' placeholder="{{'common_all_help_searchplaceholder' | i18n}}" aria-label='Search Help'
        autocomplete='off' spellcheck='false' aria-haspopup='false' role='combobox' aria-autocomplete='both' dir='ltr'
        style='outline: none;'>
      <button class='ghp-header-searchIcon ghp-searchIcon ghpv-loaded' type='submit' aria-label='Search'>
      </button>
    </form>
  </div>
  <div class="gstl_50 sbdd_a"
    style="width: 585px;; top: 49px; position: absolute; text-align: left; left: 5px; right:5px; display: block;">
    <div class="fl"></div>
    <div class="sbdd_b">
      <div class="sbsb_a">
        <ol class="sbsb_b" *ngFor="let item of searchArray">
          <li class="sbsb_c helpContent" style="text-align: left;" value="{{item.id}}">
            <a class="ghp-iconTextComponent ghp-searchPage-result ng-scope">
              <span class="ghp-iconTextComponent-icon ghp-articleIcon">
                <i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i>
              </span>
              <span class="ghp-iconTextComponent-label ng-binding">
                {{item.title}}
              </span>
            </a>
          </li>
        </ol>
      </div>
    </div>
  </div>
  <div class='ghp-header-searchRow' *ngIf="hideContentRow">
    <div id="content-view" class="ghp-content-view">
      <div class="ghp-cardContainer ng-scope">
        <div class="ghp-card">
          <div>
            <ol class="ghp-card-list ghp-searchResults ng-scope" *ngFor="let item of contentArray">
              <li class="ghp-card-listItem ng-scope helpContent" value="{{item.id}}">
                <a class="ghp-iconTextComponent ghp-searchPage-result ng-scope">
                  <span class="ghp-iconTextComponent-icon ghp-articleIcon">
                    <i class="fa fa-file-text-o fa-lg" aria-hidden="true"></i>
                  </span>
                  <span class="ghp-iconTextComponent-label ng-binding">
                    {{item.title}}
                  </span>
                </a>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-center">
    <h3 style="margin: 30%;" *ngIf="noData">{{'common_no_data_available' | i18n}}!</h3>
    <div *ngIf="displayItem" class="ghp-contentFrame" [innerHTML]="displayContent"></div>
    <div *ngIf="showLoader" class="helpLoader">
      <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></div>
  </div>
  <!-- <footer>
    <ol class="ghp-searchPanel-list" *ngIf="displayArticle">
      <li class="ghp-searchPanel-listItem">
        <a class="ghp-button ghpv-block ghpv-alignStart" target="_blank"  href="https://wiki.io-market.com/">
          <span class="ghp-button-label ghp-externalLink">
          {{'common_all_help_browse_all_articles' | i18n}}
          <i class="fa fa-forward" aria-hidden="true"></i>
          </span>
          </a>
        </li>
    </ol>
    </footer> -->
</div>